
import React, { useEffect, useState } from "react";
import TopNews2 from "../components/TopNews2";
import NewsCard from '../components/NewsCard';
import RelatedNews from '../components/RelatedNews';
import ShareButton from '../components/ShareButton';
import RecentViews from "../components/RecentViews";

import SideBar from '../components/SideBar';
import Gallery1 from '../components/Gallery1';
import axios from "axios";
import { useParams } from "react-router";

interface NewsStructure {
  id:string;
  title:string;
  img:string;
  content:string;
  date:string;
  RMBiansOfMeeting :number;
  Presentation_Second:number;
  Presentation_First:number;
  Gallery:string;
}


const NewsDetails = () => {
  const api = process.env.REACT_APP_API_URL as string;
  

  const [newData, setNewData] = useState<NewsStructure[]>([]);
    const { id } = useParams<{ id: string }>();
const numericId = Number(id);

   useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<NewsStructure[]>(
            `${api}/auth/news/${numericId}`
          );
  
        
          setNewData(response.data);
          
        } catch (error) {
          // console.error("Post Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
  return (
    <div >
        <div className="flex p-6 bg-[#efefef]">
          <div className="flex flex-col bg-white w-[80%]">
         <div><NewsCard/></div>
             <ShareButton/>
             <RelatedNews/>
             
          </div>

          <div className="w-[20%]"><SideBar/></div>
        
        </div>
    </div>
  );
};

export default NewsDetails;











